'use strict';

exports.__esModule = true;

exports.default = function (value) {
  var getType = {};
  return value && getType.toString.call(value) === '[object Function]';
};


//////////////////
// WEBPACK FOOTER
// /~/redux-form/lib/isFunction.js
// module id = vQig
// module chunks = 0